/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbEnveloppeTypeFinancementGridDto
 */
export interface FcbEnveloppeTypeFinancementGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbEnveloppeTypeFinancementGridDto
     */
    idenveloppeTypeFinancement?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbEnveloppeTypeFinancementGridDto
     */
    idanneeScolaire?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbEnveloppeTypeFinancementGridDto
     */
    idfinancementType?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbEnveloppeTypeFinancementGridDto
     */
    heureS1?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbEnveloppeTypeFinancementGridDto
     */
    heureS2?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbEnveloppeTypeFinancementGridDto
     */
    identite?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbEnveloppeTypeFinancementGridDto
     */
    centre?: string | null;
}

/**
 * Check if a given object implements the FcbEnveloppeTypeFinancementGridDto interface.
 */
export function instanceOfFcbEnveloppeTypeFinancementGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbEnveloppeTypeFinancementGridDtoFromJSON(json: any): FcbEnveloppeTypeFinancementGridDto {
    return FcbEnveloppeTypeFinancementGridDtoFromJSONTyped(json, false);
}

export function FcbEnveloppeTypeFinancementGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbEnveloppeTypeFinancementGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idenveloppeTypeFinancement': !exists(json, 'idenveloppeTypeFinancement') ? undefined : json['idenveloppeTypeFinancement'],
        'idanneeScolaire': !exists(json, 'idanneeScolaire') ? undefined : json['idanneeScolaire'],
        'idfinancementType': !exists(json, 'idfinancementType') ? undefined : json['idfinancementType'],
        'heureS1': !exists(json, 'heureS1') ? undefined : json['heureS1'],
        'heureS2': !exists(json, 'heureS2') ? undefined : json['heureS2'],
        'identite': !exists(json, 'identite') ? undefined : json['identite'],
        'centre': !exists(json, 'centre') ? undefined : json['centre'],
    };
}

export function FcbEnveloppeTypeFinancementGridDtoToJSON(value?: FcbEnveloppeTypeFinancementGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idenveloppeTypeFinancement': value.idenveloppeTypeFinancement,
        'idanneeScolaire': value.idanneeScolaire,
        'idfinancementType': value.idfinancementType,
        'heureS1': value.heureS1,
        'heureS2': value.heureS2,
        'identite': value.identite,
        'centre': value.centre,
    };
}

